import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Success from './views/Success.vue'
import Login from './views/Login.vue'
import AdminOutlet from './views/admin/AdminOutlet.vue'
import EnrollmentList from './views/admin/EnrollmentsList'
import Error from './views/Error.vue'
import BookedUp from './views/booked-up'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/error',
      name: 'error',
      component: Error,
    },
    {
      path: '/enrollment/:postId',
      name: 'home',
      component: Home
    },
      {
        path: '/booked-up',
          name: 'booked-up',
          component: BookedUp
      },
    {
      path: '/enrollment/:postId/success',
      name: 'success',
      component: Success
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/admin',
      component: AdminOutlet,
      children: [
        {path: '', redirect: 'enrollments'},
        {
          path: 'users',
          name: 'users',
        },
        {
          path: 'enrollments',
          name: 'enrollments',
          component: EnrollmentList
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router.js